import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.chat.activity');
import { OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

export interface ActivityItem {
    id: string;
    task: string;
    status: 'pending' | 'working' | 'done' | 'error';
    progress?: string;
    error?: string;
    tags?: { label: string; title?: string; page?: number }[];
}

@Component({
    selector: 'wiz-portal-nrich-chat-activity',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichChatActivityComponent implements OnInit, OnChanges {
    @Input() activities: ActivityItem[] = [];
    @Input() status: 'working' | 'done' = 'working';
    @Output() pageClick = new EventEmitter<number>();

    public expanded: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['status'] && this.status === 'done') {
            // 완료 시 자동 접기 (800ms 후)
            setTimeout(() => {
                this.expanded = false;
                this.service.render();
            }, 800);
        }
        await this.service.render();
    }

    public get completedCount(): number {
        return this.activities.filter(a => a.status === 'done').length;
    }

    public toggleExpand() {
        this.expanded = !this.expanded;
    }

    public onTagClick(tag: any) {
        if (tag.page) {
            this.pageClick.emit(tag.page);
        }
    }
}

export default PortalNrichChatActivityComponent;